var defaultOptions = {
    container: null,
    buttonSelector: '[data-tab-target]',
    tabSelector: '.sliding-tab',
    classes: {
        active: 'sliding-tab--active',
        inRight: 'sliding-tab--in-right',
        inLeft: 'sliding-tab--in-left',
        outRight: 'sliding-tab--out-right',
        outLeft: 'sliding-tab--out-left'
    },
    activeButtonClass: 'tab-button--active',
    inactiveButtonClass: 'tab-button--inactive',
    disabledButtonClass: 'tab-button--disabled'
};

export default function SlidingTabs(options) {
    this.config = Object.assign(defaultOptions, options || {});

    this.create();
};

SlidingTabs.prototype.create = function () {
    this.container = typeof this.config.container === 'string'
        ? document.querySelector(this.config.container)
        : this.config.container;

    if (!this.container) {
        console.error('[SlidingTabs] Container not found');
        return;
    }

    this.tabs = Array.from(this.container.querySelectorAll(this.config.tabSelector));
    this.buttons = Array.from(this.container.querySelectorAll(this.config.buttonSelector));
    this.currentTab = this.tabs.find(tab => tab.classList.contains(this.config.classes.active)) || this.tabs[0];

    this.updateButtonStates(this.currentTab.id);
    this.initTabs();

    this.buttons.forEach(button => {
        const targetId = button.getAttribute('data-tab-target');
        const isDisabled = button.hasAttribute('data-tab-disabled');

        if (isDisabled) {
            button.setAttribute('disabled', 'disabled');

            if (this.config.disabledButtonClass) {
                button.classList.add(...this.config.disabledButtonClass.split(/\s+/));
            }

            return;
        }

        if (targetId) {
            button.addEventListener('click', () => {
                this.switch(targetId);
            });
        }
    });
};

SlidingTabs.prototype.initTabs = function () {
    const c = this.config.classes;
    this.tabs.forEach((tab, index) => {
        tab.classList.remove(c.active, c.inRight, c.inLeft, c.outRight, c.outLeft);
        tab.classList.add(index === 0 ? c.active : c.inRight);
        tab.style.zIndex = index === 0 ? 100 : 0;
    });
};

SlidingTabs.prototype.updateButtonStates = function (activeId) {
    const removeClasses = (el, classString) => {
        if (!classString) return;
        classString.split(/\s+/).forEach(cls => {
            if (cls) el.classList.remove(cls);
        });
    };

    const addClasses = (el, classString) => {
        if (!classString) return;
        classString.split(/\s+/).forEach(cls => {
            if (cls) el.classList.add(cls);
        });
    };

    this.buttons.forEach(button => {
        const isActive = button.getAttribute('data-tab-target') === activeId;

        removeClasses(button, this.config.activeButtonClass);
        removeClasses(button, this.config.inactiveButtonClass);

        if (isActive) {
            addClasses(button, this.config.activeButtonClass);
        } else {
            addClasses(button, this.config.inactiveButtonClass);
        }
    });
};

SlidingTabs.prototype.switch = function (targetId) {
    const c = this.config.classes;
    const targetTab = this.tabs.find(tab => tab.id === targetId);
    if (!targetTab || targetTab === this.currentTab) return;

    const currentIndex = this.tabs.indexOf(this.currentTab);
    const targetIndex = this.tabs.indexOf(targetTab);
    const isForward = targetIndex > currentIndex;

    // Reset z-index
    this.tabs.forEach(tab => tab.style.zIndex = 0);
    targetTab.style.zIndex = 100;

    // Prepare target tab
    targetTab.classList.remove(c.active, c.inRight, c.inLeft, c.outRight, c.outLeft);
    targetTab.classList.add(isForward ? c.inRight : c.inLeft);

    // Force reflow to restart animation
    void targetTab.offsetHeight;

    // Animate current tab out
    this.currentTab.classList.remove(c.active);
    this.currentTab.classList.add(isForward ? c.outLeft : c.outRight);

    // Animate target tab in
    targetTab.classList.remove(c.inRight, c.inLeft);
    targetTab.classList.add(c.active);

    // Update button state
    this.updateButtonStates(targetId);

    // Set current tab
    this.currentTab = targetTab;
};

